import _ from 'lodash';
import { useMemo } from 'react';
import { Outlet } from 'react-router';
import Sider from 'app/layout/components/Sider';
import Header from 'app/layout/components/header/Header';
import MainInfo from 'containers/brandSetting/MainInfo';
import { Content } from 'app/layout/components';
import { useLayout } from 'contexts/LayoutContext';
import { getSidebarSizes } from 'utils/styledHelpers';
import type { BrandSettingLayoutProps } from 'layouts/types';
import { arrayToTree } from 'utils/utils';
import Notification from 'app/layout/components/Notification';
import { StyledLayout, StyledMainSettingsWrapper } from './Layouts.styled';

const sidebarSizes = getSidebarSizes();

const BrandSettingLayout = ({
  routers = [],
  page = '',
  width = sidebarSizes.width,
  collapsedWidth = sidebarSizes.collapsedWidth,
}: BrandSettingLayoutProps) => {
  const { hideLayout } = useLayout();

  const newData = useMemo(
    () => _.cloneDeep(routers).filter(
      (el) => el.menuItem && !el.hide?.(),
    ),
    [routers],
  );

  const menus = useMemo(
    () => arrayToTree(newData, 'id', 'menuParentId'),
    [newData],
  );

  if (hideLayout) {
    return (
      <StyledLayout>
        <Content noPadding>
          <Outlet />
        </Content>
      </StyledLayout>
    );
  }

  return (
    <>
      <Notification />
      <Header
        collapsedWidth={collapsedWidth}
        width={width}
      />

      <StyledLayout $isBrand>
        {!!newData.length && (
          <Sider
            menus={menus}
            collapsedWidth={collapsedWidth}
            width={width}
            page={page}
          />
        )}

        <Content>
          <StyledMainSettingsWrapper>
            <MainInfo />
          </StyledMainSettingsWrapper>
          <Outlet />
        </Content>
      </StyledLayout>
    </>
  );
};

export default BrandSettingLayout;
